import { Select } from "@chakra-ui/react";
import React, { useState } from "react";
import BraceletsSizeDialog from "./BraceletsSizeDialog";

const BraceletSizeSelector = ({
  selectedProduct,
  selectedBraceletSizeMen,
  setSelectedBraceletSizeMen,
  selectedBraceletSizeWomen,
  setSelectedBraceletSizeWomen,
}) => {
  const [isBraceletSize, setIsBraceletSize] = useState(false);

  const isForCouples = selectedProduct?.subcategories?.some(
    (subcat) => subcat.name === "FOR COUPLES"
  );

  const gender = selectedProduct?.gender;

  return (
    <>
      <div className="pb-3">
        <div className="flex items-center gap-2 mb-2">
          <label htmlFor="sizeSelect">Bracelet Size:</label>
          <div
            className="underline cursor-pointer text-sm text-[#000080]"
            onClick={() => setIsBraceletSize(true)}
          >
            Size Chart
          </div>
        </div>

        {isForCouples ? (
          <div className="flex w-full gap-6">
            <div>
              <label htmlFor="menSizeSelect">Men Size</label>
              <Select
                id="menSizeSelect"
                border="1px solid"
                _hover="none"
                className="px-4 pt-0 mt-2"
                width="45"
                borderColor="#000080"
                value={selectedBraceletSizeMen}
                onChange={(e) => setSelectedBraceletSizeMen(e.target.value)}
                required
              >
                <option value="">Select Men Size</option>
                <option value="Small (S)">Small (S)</option>
                <option value="Medium (M) (Fit Most Men)">Medium (M) (Fit Most Men)</option>
                <option value="Large (L)">Large (L)</option>
                <option value="X-Large (XL)">X-Large (XL)</option>
              </Select>
            </div>
            <div>
              <label htmlFor="womenSizeSelect">Women Size</label>
              <Select
                id="womenSizeSelect"
                border="1px solid"
                _hover="none"
                className="px-4 pt-0 mt-2"
                width="45"
                borderColor="#000080"
                value={selectedBraceletSizeWomen}
                onChange={(e) => setSelectedBraceletSizeWomen(e.target.value)}
                required
              >
                <option value="">Select Women Size</option>
                <option value="Small (S) (Fit Most Women)">Small (S) (Fit Most Women)</option>
                <option value="Medium (M)">Medium (M)</option>
                <option value="Large (L)">Large (L)</option>
                <option value="X-Large (XL)">X-Large (XL)</option>
              </Select>
            </div>
          </div>
        ) : (
          <Select
            id="sizeSelect"
            border="1px solid"
            _hover="none"
            className="px-4 pt-0"
            width="40"
            borderColor="#000080"
            value={gender === "male" ? selectedBraceletSizeMen : selectedBraceletSizeWomen}
            onChange={(e) => {
              if (gender === "male") {
                setSelectedBraceletSizeMen(e.target.value);
              } else {
                setSelectedBraceletSizeWomen(e.target.value);
              }
            }}
            required
          >
            <option value="">Select Size</option>
            <option value="Small (S) (Fit Most Women)">
              Small (S)
              {gender === "female" || gender === "unisex" ? " (Fit Most Women)" : ""}
            </option>
            <option value="Medium (M) (Fit Most Men)">
              Medium (M)
              {gender === "male" || gender === "unisex" ? " (Fit Most Men)" : ""}
            </option>
            <option value="Large (L)">Large (L)</option>
            <option value="X-Large (XL)">X-Large (XL)</option>
          </Select>
        )}

        <BraceletsSizeDialog
          isOpen={isBraceletSize}
          onClose={() => setIsBraceletSize(false)}
        />
      </div>
    </>
  );
};

export default BraceletSizeSelector;
